<nav class="navbar navbar-expand-lg navbar-dark bg-primary navbar-main">
	<div class="container">
		<a class="navbar-brand me-5 py-1" routerLink="/">
			<img src="assets/img/logo-new.png" height="50" alt="US DOJ CORA Portal" />
			<span class="fs-1 ms-4 align-middle">CORA</span>
		</a>
		<button
			class="navbar-toggler"
			type="button"
			data-bs-toggle="collapse"
			data-bs-target="#navbarSupportedContent"
			aria-controls="navbarSupportedContent"
			aria-expanded="false"
			aria-label="Toggle navigation"
		>
			<span class="navbar-toggler-icon"></span>
		</button>
		<div class="collapse navbar-collapse" id="navbarSupportedContent">
			<ul class="navbar-nav me-auto mb-2 mb-lg-0">
				@if (isAuthenticated()) {
					<li class="nav-item me-4" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">
						<a class="nav-link" routerLink="/dashboard">Dashboard</a>
					</li>
				}
			</ul>
			@if (isAuthenticated()) {
				@if (email()) {
					<span class="text-light me-3">{{ email() }}</span>
				}
				<button class="btn btn-outline-light" type="button" (click)="logOut()">Log Out</button>
			} @else if (portalOpen) {
				<button class="btn btn-outline-light me-2" type="button" (click)="logIn()">Log In or Create Account</button>
			} @else {
				<!--
					Portal not open yet. Takes the sign-in button's place rather than
					sitting alongside it, so there is nothing to click that would send an
					applicant to an account they can't use yet. Authenticated visitors are
					unaffected — the branch above still offers Log Out.
				-->
				<span class="navbar-text text-light small me-2">Applications open {{ opensLabel }}.</span>
			}
		</div>
	</div>
</nav>
